import { render, staticRenderFns } from "./WorkerMainUI.vue?vue&type=template&id=dc8ad6d0&scoped=true"
import script from "./WorkerMainUI.vue?vue&type=script&lang=js"
export * from "./WorkerMainUI.vue?vue&type=script&lang=js"
import style0 from "./WorkerMainUI.vue?vue&type=style&index=0&id=dc8ad6d0&prod&lang=scss&scoped=true"
import style1 from "./WorkerMainUI.vue?vue&type=style&index=1&id=dc8ad6d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8ad6d0",
  null
  
)

export default component.exports